var styles = {"pendingMessage":"styles_pending-message__icMII","appear":"styles_appear__gtO6I","noDebouncing":"styles_no-debouncing__FPhQI","icon":"styles_icon__k4Sik","message":"styles_message__-yB9X","compact":"styles_compact__rZod-"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
